/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

import Card from "@mui/material/Card";
import { formatDate } from "utils";
import SoftBox from "components/SoftBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell/index";
import { LoanDetailLedgerService } from "services/loan-detail-ledger";

const renderData = (items, setDataTable) => {
  return items.map((item) => {
    return {
      id: item._id,
      accountNumber: item.accountNumber || "341",
      lenderName: item.lenderName || "",
      loanAgreementNumber: item.loanAgreementNumber || "",
      unit: item.unit || "",
      ledgerClerk: item.ledgerClerk || "",
      createdAt: formatDate(item.createdAt),
      action: <ActionCell item={item} setDataTable={setDataTable} />,
    };
  });
};

const tableData = {
  columns: [
    { Header: "Tài khoản", accessor: "accountNumber", width: "10%" },
    { Header: "Đối tượng cho vay", accessor: "lenderName", width: "25%" },
    { Header: "Số khế ước", accessor: "loanAgreementNumber", width: "15%" },
    { Header: "Đơn vị", accessor: "unit", width: "20%" },
    { Header: "Người ghi sổ", accessor: "ledgerClerk", width: "15%" },
    { Header: "Ngày tạo", accessor: "createdAt", width: "15%" },
    { Header: "Thao tác", accessor: "action", sorted: false },
  ],
  rows: [],
};

function LoanDetailLedger() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({ sortBy: "createdAt", sortType: "desc" });
  const [checkCreate, setCheckCreate] = useState(true);
  const [paginationData, setPaginationData] = useState({
    page: 1,
    count: 0,
    size: 10,
  });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const response = await LoanDetailLedgerService.getPaginate({
        ...query,
        page: paginationData.page,
        size: paginationData.size,
      });

      const { items, checkCreate: createPerm, paginate } = response.data || response;
      setCheckCreate(createPerm ? false : true);
      setPaginationData((prev) => ({
        ...prev,
        count: paginate?.count || 0,
        size: paginate?.size || 10,
      }));

      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items || [], setDataTable),
      }));

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Lỗi lấy dữ liệu Sổ S34-DN:", error);
      setDataTable((prev) => ({ ...prev, rows: [] }));
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            checkCreate={checkCreate}
            query={query}
            table={dataTable}
            loading={loading}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default LoanDetailLedger;
